/* 
 * QuizAnswerSubmitContent.js
 * Created on 5-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import Content from "./Content";
import ContentTypes from "./ContentTypes";

export default class QuizAnswerSubmitContent extends Content {
    constructor(languagePack, contentID, label) {
        super(QuizAnswerSubmitContent.NAME, QuizAnswerSubmitContent.TYPE, label, languagePack, contentID);

        this._localLanguagePack = languagePack;
        this._localContentID = contentID;
        this._localLabel = label;
    }

    remove() {
        super.remove();
    }

    clone() {
        return ContentFactory.getContent(ContentTypes.TYPE_QUIZANSWER_SUBMIT, this._localLanguagePack);
    }

    setPropertiesFromObject(object) {
        super.setPropertiesFromObject(object);
    }

    getDescriptionLabel() {
        return "Quiz Answer Submit";
    }
}


QuizAnswerSubmitContent.TYPE = ContentTypes.TYPE_QUIZANSWER_SUBMIT;
QuizAnswerSubmitContent.NAME = "Quiz Answer Submit Content";
